import { main } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

const { banner } = main;
const createPositionCacheKey = (position = {}) => {
  const latitude = Number(position?.latitude ?? 0).toFixed(6);
  const longitude = Number(position?.longitude ?? 0).toFixed(6);
  return `${latitude}:${longitude}`;
};

export default {
  FETCH_BANNER: async ({ commit, rootGetters }, payload = {}) => {
    const position = rootGetters['user/getUserPosition'];
    const response = await ServiceExec.get(banner, position, { ...payload });
    if (!response) return [];
    const { status } = response;
    if (!Array.isArray(response.data)) return [];
    const data = response.data;
    if (status === ServiceExec.status.OK) {
      commit('setBanners', data);
      commit('setCacheMeta', {
        fetchedAt: Date.now(),
        locationKey: createPositionCacheKey(position)
      });
    }
  }
};
